import { always, anyPass, compose, cond, not, T } from 'ramda';
import { FileType } from '../constants/FileType';
import { IntlFormatters } from 'react-intl';

export const getReadableFileSize = (size: number, formatNumber: IntlFormatters['formatNumber']): string => {
  const fileSizeTypes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const countOfFileSizeTypes = fileSizeTypes.length;
  const multiplier = 1000;
  let i = 0;
  let newSize = size;

  while (i < countOfFileSizeTypes && newSize > multiplier) {
    newSize = newSize / multiplier;
    i += 1;
  }

  const formattedSize = formatNumber(newSize, { maximumFractionDigits: i > 1 ? 1 : 0 });

  return `${formattedSize}${fileSizeTypes[i]}`;
};

type TIsTypeFile = (mime: string) => boolean;
const isTypeFile: (regType: RegExp) => TIsTypeFile = (regType) => (mime) => regType.test(mime);

export const isImageFile: TIsTypeFile = isTypeFile(/^image\//i);
export const isVectorArtFile: TIsTypeFile = isTypeFile(/image\/svg\+xml/i);
export const isVideoFile: TIsTypeFile = isTypeFile(/^video\//i);
export const isAudioFile: TIsTypeFile = isTypeFile(/^audio\//i);
export const isZipFile: TIsTypeFile = isTypeFile(/application\/(x-)?zip/i);
export const isSWFFile: TIsTypeFile = isTypeFile(/application\/x-shockwave-flash/i);
export const isDocumentFile: TIsTypeFile = compose(not, anyPass([isImageFile, isVideoFile, isAudioFile]));

export const getFileTypeFromMime: (mime: string) => FileType = cond([
  [isVectorArtFile, always(FileType.VectorArt)],
  [isSWFFile, always(FileType.SWF)],
  [isImageFile, always(FileType.Image)],
  [isVideoFile, always(FileType.Video)],
  [isAudioFile, always(FileType.Audio)],
  [isZipFile, always(FileType.Zip)],
  [T, always(FileType.Document)],
]);
